import { type FunctionComponent, } from "react"
import { Button, } from "@bracket/react-button";
import { Chip, } from "@bracket/react-chip";

import "./FourOhFour.scss";



export declare type FourOhFourProps = {

};


export const FourOhFour: FunctionComponent<FourOhFourProps> = ({

}) => {

	const classes = () => [ `four-oh-four` ].join(" ");
	const onSupport = () => {

	};

	return (
	<div className={classes()}>
		<div className="screen">
			<div className="brace">
				<div className="chipped">
					<Chip><span>404</span></Chip>
				</div>
				<h1>Page not found</h1>
				<div className="button-bar">
					<Button label="Return home" onClick={() => { window.location.href = "/" }} />
				</div>
			</div>
		</div>
	</div>
	);

}

